module.exports = __webpack_public_path__ + "img/keenBackBorder@2x.5e00d584.png";